/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface BaseResponseWithTimezone
 */
export interface BaseResponseWithTimezone {
    /**
     * 
     * @type {string}
     * @memberof BaseResponseWithTimezone
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof BaseResponseWithTimezone
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof BaseResponseWithTimezone
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof BaseResponseWithTimezone
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the BaseResponseWithTimezone interface.
 */
export function instanceOfBaseResponseWithTimezone(value: object): value is BaseResponseWithTimezone {
    return true;
}

export function BaseResponseWithTimezoneFromJSON(json: any): BaseResponseWithTimezone {
    return BaseResponseWithTimezoneFromJSONTyped(json, false);
}

export function BaseResponseWithTimezoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseResponseWithTimezone {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function BaseResponseWithTimezoneToJSON(json: any): BaseResponseWithTimezone {
    return BaseResponseWithTimezoneToJSONTyped(json, false);
}

export function BaseResponseWithTimezoneToJSONTyped(value?: BaseResponseWithTimezone | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

